import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import Pagination from "./Pagination";
import { GetApi, PatchApi } from "./Helper/Axios";

export default function Purchase() {
  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const token = localStorage.getItem("token");
  const limit = 10;

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  useEffect(() => {
    getAll();
  }, [currentPage]);

  const getAll = async () => {
    const url = `purchases?page=${currentPage}&limit=${limit}`;
    try {
      const res = await GetApi(url, token);
      console.log("API Response:", res.data.data); 
      setData(Array.isArray(res.data.data.data) ? res.data.data.data  : []); 
      setTotalPages(res.data.data.totalPages || 1); 
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]); // Reset data on error
    }
  };

  const handleStatusChange = async (id) =>{
    let url = `purchase/${id}`;
    const token = localStorage.getItem("token");

    let res = await PatchApi(url, null, false, token);
    console.log("handleStatusChange:", res.data);
    getAll();
  }

  return (
    <div>
      <Table className="mytable">
        <thead>
          <tr>
            <td>Id</td>
            <td>User ID</td>
            <td>DeviceID</td>
            <td>Plan ID</td>
            <td>Amount</td>
            <td>Gateway</td>
            <td>Duration Type</td>
            <td>Start Date</td>
            <td>End Date</td>
            <td>Coins</td>
            <td>Status</td>
            <td>Action</td>
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <tr key={index}>
              <td>{item.id}</td>
              <td>{item.user_id}</td>
              <td>{item.userData?.device_id}</td>
              <td>{item.plan_id}</td>
              <td>{item.amount}</td>
              <td>{item.gateway}</td>
              <td>{item.duration_type}</td>
              <td>{new Date(item.start_date).toLocaleString()}</td>
              <td>{new Date(item.end_date).toLocaleString() }</td>
              <td>{item.coins}</td>
              <td>{item.is_expired ? <h2 className="text-lg text-muted">⨷</h2> : item.status ? <h2 className="text-success text-lg"> ✔</h2>: <h2 className="text-danger">✘</h2>}</td>
              <td><button className="btn btn-sm btn-info" disabled={item.is_expired} onClick={()=>{handleStatusChange(item.id)}}>↶ Status</button></td>
            </tr>
          ))}
        </tbody>
      </Table>

      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onNext={handleNextPage}
        onPrev={handlePrevPage}
        handlePageChange={handlePageChange}
      />
    </div>
  );
}
